import Analytics from '../Analytics';
import {tokenParam} from '../linkOutSession';

export const UserAlreadySubscribedMessage = 'User already subscribed';

export const bypassCheckoutForDuplicateCustomer = (code: string, token: string | null) => {
  reportRepeatCheckout(code, token);
  redirectToSuccess(code, token);
};

export const redirectToSuccess = (code: string, token: string | null) => {
  if (token) {
    window.location.href = `${document.location.origin}/offer/success?${tokenParam(token, {encode: true})}code=${code}`;
  } else {
    window.location.href = `${document.location.origin}/offer/success?code=${code}`;
  }
};

export const reportRepeatCheckout = (code: string, token: string | null) => {
  Analytics.track(`Attempted to use Stripe checkout again`, {code, token});
};
